var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.32092C2.5 2.59171 3.09171 2 3.82092 2C4.54967 2 5.14138 2.59171 5.14183 3.32092C5.14183 4.05013 4.55013 4.65421 3.82092 4.65421C3.09171 4.65421 2.5 4.05013 2.5 3.32092Z",
    fill: "#253172"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 12.9998V8.96555C13.5001 6.99197 13.0752 5.47168 10.768 5.47168C9.65879 5.47168 8.91445 6.08035 8.61058 6.65739H8.5785V5.65593H6.39087V12.9998H8.66879V9.36339C8.66879 8.40593 8.85029 7.4801 10.036 7.4801C11.2043 7.4801 11.2217 8.57276 11.2217 9.4248V13.0003L13.5001 12.9998Z",
    fill: "#253172"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68164 5.65625H4.96231V13.0001H2.68164V5.65625Z",
    fill: "#253172"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4534c75b6755bb639745d00c4ffa3789.svg";
export { ForwardRef as ReactComponent };